import { type Selection } from '@noths/polaris-product-listings-urls';

import type { Facet } from 'src/redux/productsQuery/types/Facet';

/**
 * Maps active facet options to the `{ alias, values }` selections the URL builder
 * consumes. Taxonomy and filter facets are returned together — `build` partitions
 * them by whether each alias is registered as taxonomy.
 */
export const facetsToSelections = (facets: Facet[]): Selection[] =>
  facets
    .map((facet) => ({
      alias: facet.alias,
      values: facet.options.filter((option) => option.active).map((option) => option.value),
    }))
    .filter((selection) => selection.values.length > 0);
